module.exports = __webpack_public_path__ + "6c4a0dbc/img/share-action-icon.9c12578c.svg";